<template>
    <span v-html="html"></span>
</template>
<script>
// Highlight the searched substring of orig_string with `bg-warning`
export default {
    props: {
        orig_str: String,
        search: {
            type: String,
            default: ''
        }
    },

    computed: {
        html(){
            return this.search.length 
                    ? this.orig_str.replace(new RegExp(this.search, "gi"), match => `<span class="bg-warning">${match}</span>`)
                    : this.orig_str
        }
    }
}
</script>
